/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsPlatformProvider extends models.FilterOptionsPlatformProviderLight {
    getFixupPrototypeFunction() { return FilterOptionsPlatformProvider.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsPlatformProvider>): FilterOptionsPlatformProvider {
        let obj = Object.assign(new FilterOptionsPlatformProvider(), model);
        FilterOptionsPlatformProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsPlatformProvider>): FilterOptionsPlatformProvider {
        if (!model) return null;
        return FilterOptionsPlatformProvider.newInstance(<FilterOptionsPlatformProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsPlatformProvider) {
        if (!obj) return;

        models.FilterOptionsPlatformProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsPlatformProvider): boolean {
        if (models.FilterOptionsPlatformProviderLight.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsPlatformProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.platform_accounts) {
            for (let val of this.platform_accounts) {
                models.FilterOptionsPlatformAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * List of accounts for this Platform
     */
    platform_accounts: Array<models.FilterOptionsPlatformAccount>;

}
